export default {
    photographerAgreement: { list: [] }
};
